import { render } from "./Gift.vue?vue&type=template&id=486e2683&scoped=true"
import script from "./Gift.vue?vue&type=script&lang=js"
export * from "./Gift.vue?vue&type=script&lang=js"

import "./Gift.vue?vue&type=style&index=0&id=486e2683&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486e2683"]])

export default __exports__